import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportCenterDialogComponent, ReportCenterReportDefinition } from './rc-dialogs/report-center-dialog.cmp';
import { ReportsCenterData } from './reports-center.data';

@Component({
  selector: 'app-reports-center',
  templateUrl: './reports-center.component.html',
  styleUrls: ['./reports-center.component.scss']
})
export class ReportsCenterComponent  {
    private reportConfigs: ReportCenterReportDefinition[] = [
        {
            key: 'contactsPlansStatuses',
            title: 'דו"ח תוכניות לטיפול ואנשים ללא תוכנית',
            description: 'מעקב אחר תוכניות לטיפול, תשלומים פעילים ואנשים ללא תוכנית מסודרת.',
            icon: 'fa-users',
            excelFileName: 'דוח תוכניות לטיפול ואנשים ללא תוכנית',
            filters: {
                page: [1],
                pageRows: [5000],
                query: [],
                contactID: [],
                paymentsPlanID: [],
                contactName: [],
                paymentsPlanTypes: [null],
                fromDateRange: [],
                tillDateRange: [],
                pulseAmountRange: [],
                commitmentID: [],
                withTillDate: [null],
                cityIDs: [null],
                shtibelID: [],
                commitmentSubjects: [[]],
                shtibelName: [],
                orderByShtibel: [false],
                withPaymentsForTreatment: [null],
                activePaymentsPlans: [null],
                selectedRows: [[]],
                orders: [[]]
            },
            fields: [
                { key: 'commitmentSubjects', type: 'multiSelect', placeholder: 'נושא...', listKey: 'CommitmentSubjects', keyProperty: 'value', titleProperty: 'name' },
                { key: 'cityIDs', type: 'multiSelect', placeholder: 'עיר...', listKey: 'Cities', keyProperty: 'id', titleProperty: 'title' },
                { key: 'shtibelID', type: 'autoComplete', placeholder: 'שטיבל...', controllerName: 'Shtibels', idControlKey: 'shtibelID', nameControlKey: 'shtibelName' },
                { key: 'fromDateRange', type: 'dateRange', label: 'החל מתאריך', placeholder: 'עד לתאריך' },
                { key: 'pulseAmountRange', type: 'amountRange', label: 'מסכום חודשי', placeholder: 'עד סכום' },
                {
                    key: 'withTillDate', type: 'select', label: 'תאריך סיום', placeholder: 'תאריך סיום...', options: [
                        { value: '', title: 'הכל' },
                        { value: true, title: 'כולל' },
                        { value: false, title: 'לא כולל' }
                    ]
                },
                {
                    key: 'withPaymentsForTreatment', type: 'select', label: 'תשלומים לטיפול', placeholder: 'תשלומים לטיפול...', options: [
                        { value: '', title: 'הכל' },
                        { value: true, title: 'רק לטיפול' },
                        { value: false, title: 'רק לא לטיפול' }
                    ]
                },
                {
                    key: 'activePaymentsPlans', type: 'select', label: 'תוכניות פעילות', placeholder: 'תוכניות פעילות...', options: [
                        { value: '', title: 'הכל' },
                        { value: true, title: 'רק פעילים' },
                        { value: false, title: 'רק לא פעילים' }
                    ]
                },
                { key: 'orderByShtibel', type: 'checkbox', label: 'מיון לפי שטיבל' },
                { key: 'query', type: 'text', label: 'חיפוש חופשי', placeholder: 'שם, הערה, user:...' }
            ],
            columns: []
        },
        {
            key: 'paymentsForTreatments',
            title: 'דו"ח תשלומים שנכשלו',
            description: 'רשימת תשלומים שחזרו למעקב וטיפול לפי טווח ימים אחורה.',
            icon: 'fa-credit-card',
            excelFileName: 'דוח תשלומים שנכשלו',
            filters: {
                daysBack: [7]
            },
            fields: [
                { key: 'daysBack', type: 'number', label: 'ימים אחורה', placeholder: 'הכנס מספר ימים' }
            ],
                        columns: []
        }
    ];

        public reports: ReportCenterReportDefinition[] = [];

  constructor(
        public dialog: MatDialog,
        private reportsCenterData: ReportsCenterData) {
            this.reports = this.reportConfigs.map(reportConfig => ({ ...reportConfig }));

            this.reportsCenterData.getDefinitions().subscribe(
                (definitions: any) => {
                    const definitionsByKey = (definitions || []).reduce((accumulator: any, current: any) => {
                        accumulator[current.key] = current;
                        return accumulator;
                    }, {});

                    this.reports = this.reportConfigs.map(reportConfig => {
                        const definition = definitionsByKey[reportConfig.key] || {};
                        return {
                            ...reportConfig,
                            title: definition.title || reportConfig.title,
                            description: definition.description || reportConfig.description,
                            icon: definition.icon || reportConfig.icon,
                            excelFileName: definition.excelFileName || reportConfig.excelFileName,
                            columns: definition.columns || reportConfig.columns || []
                        };
                    });
                },
                () => {
                    this.reports = this.reportConfigs.map(reportConfig => ({ ...reportConfig }));
                }
            );
        }


  openReport(report: ReportCenterReportDefinition): void {
    setTimeout(() => {
      this.dialog.open(ReportCenterDialogComponent, {
        data: report,
        width: '960px',
        maxWidth: '95vw',
        autoFocus: false,
        panelClass: 'report-center-modal'
      });
    }, 150);
  }
}
